import { useEffect, useRef, useState } from "react";
export function useScopeWidth() {
    const scopeHeaderRef = useRef<HTMLTableCellElement>(null);
    const [scopeWidth, setScopeWidth] = useState(0);
    useEffect(() => {
        const current = scopeHeaderRef.current;
        const observer = new ResizeObserver((entries) => {
            setScopeWidth(entries[0].contentRect.width);
        });
        if (current) {
            observer.observe(current);
        }
        return () => {
            if (current) {
                observer.unobserve(current);
            }
        };
    }, []);
    return { scopeHeaderRef, scopeWidth };
}
